import React, { useRef, useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import * as Yup from "yup";
import { useFormik } from "formik";
import TextInput from "../../common/textfield/TextInput";
import SelectFiled from "../../common/textfield/SelectFiled";
import { useNavigate } from "react-router-dom";
import { Button } from "../../common/Button";
import { failed, success } from "../../common/Toastify";
import { decryptData, encryptData } from "../../EncryptDecrypt";
import {
  typeOptions,
  createAccountOptions,
  caregions,
  usregions,
  countryList,
  FormikObjEdit,
  relationsList,
  editBasicFieldsAPI
} from "./Constants";
import { useOrgQuery } from "../../../hooks/ReactQueryHooks/useOrgQuery";
import MultiSelect from "../../common/textfield/MultiSelect";
import { Skeleton, Tooltip } from "@mui/material";
import {
  editUser,
  getCustomRoles,
  updateAgentId,
  getSingleUser
} from "../../api/Individual";
import FilterSelect from "../../common/textfield/FilterSelect";
import { useClinicLocationsQuery } from "../../../hooks/ReactQueryHooks/useClinicLocationsQuery";
import { Clear } from "@mui/icons-material";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import { FullPageSpinner } from "../../common/Spinner/FullPageSpinner";
import { useSelector } from "react-redux";
import Switch from '@mui/material/Switch';
import { ViewDate } from "../../../utils/DateSupport";
import Fields from "./Fields";
import UpdateDetailsIcon from "../../../assets/images/update.svg"
import { getDiscover } from "../../api/Organization";

function EditApiAccount({
  modalShow,
  handleShow,
  refreshTable,
  isReadOnly,
  typeOfUser,
  organizations,
  organizationsData,
  handleDelete,
  handleEnableClick    
}) {
  const navigate = useNavigate();
  const onSuccessLocations = (data) => {
    setLocations(
      data?.map((location) => (location = { ...location, value: location?.id }))
    );
  };
  useClinicLocationsQuery({ onSuccess: onSuccessLocations });
  const [locations, setLocations] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [loadingUserData, setLoadingUserData] = useState(false);  
  const [createdAt, setCreatedAt] = useState('');
  const [defaultValue, setDefaultValue] = useState([]); 
  //For Setting scope of jurisdictions
  //For selecting role and showing jurisdictions
  //For selecting org and showing roles  of that org
  const [orgSelected, setOrgSelected] = useState(false);
  const [rolesOptions, setRolesOptions] = useState([{ name: "-----" }]);
  const [typeStatus, setTypeStatus] = useState(true);
  const [createAccount, setCreateAccount] = useState(false);
  const [createAccountValue, setCreateAccountValue] = useState(true);
  const user = useSelector((state) => state?.auth?.user);
  const isCTIEnabledRef = useRef();
  const userRoles = useSelector((state) => state?.auth?.user?.["cognito:groups"]);
  const hasAccess = (userRoles?.includes("Super-Admin"));
  
  if(!hasAccess) {
    isReadOnly = true;
    typeOfUser = ""
  }

  //For getting general Practiotioner data and setting the list and options
  // const [generalPractitionerOptions, setGeneralPractitionerOptions] = useState(
  //   []
  // );
  // const [generalPractitionerData, setGeneralPractitionerData] = useState([]);
  const adminOrgs = useSelector((state) => state?.auth?.user?.organizations)

  //Handle change function for org selection and showing roles w.r.to selected org
  const handleOrgChange = async (event) => {
    const value = event?.target?.value;
    setOrgSelected(true);
    formik.setFieldValue("organization", value);
    
    await setCTIstatus(value);
  };

  const handleSwitch = () => {
    modalShow?.active ? handleDelete(modalShow?.id, modalShow.name?.[0]?.text) 
    : handleEnableClick(modalShow?.id, modalShow.name?.[0]?.text)
  }

  const setCTIstatus = async(orgId) => {
    formik.setFieldValue("agentId", "");
    const response = await getDiscover(orgId);
    isCTIEnabledRef.current = response?.data?.licensedProduct?.CTI;
  }
  //Handle change function for role selection and showing scope of jurisdiction w.r.to selected role
//   const handleRoleChange = (event) => {
//     const value = event?.target?.value;
//     formik.setFieldValue("role", value);
//     const roleType = rolesOptions.filter((role) => role?.id === value);
//     //If type clinical then show scope of jurisdiction
//     if (
//       roleType[0]?.type === "Clinical" ||
//       roleType[0]?.type === "Administrative_Clinical"
//     ) {
//       setRoleSelected(true);
//     } else {
//       formik.setFieldValue("countrylist", "");
//       formik.setFieldValue("jurisdiction", []);
//       setRoleSelected(false);
//     }
//   };



  const formik = useFormik({
    ...FormikObjEdit,
      initialValues: {
        ...FormikObjEdit.initialValues,
        type:  "API",
        create_account: false
      },
      validationSchema: Yup.object({
        account_name: Yup.string()
          .max(50, "Must be 50 characters or less")
          .required("Required account name field")
          .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
      
        email: Yup.string().when("create_account", (type, schema) =>
          createAccountValue
            ? schema
                .email("Invalid email address")
                .required("Required email field")
                .matches(/^$|^\S+.*/, "Only blankspaces is not valid.")
            : schema.email("Invalid email address").required("Required email field")
        ),
      
        type: Yup.string()
          .required("Required type field")
          .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
      
        organization: Yup.string()
          .required("Required organization")
          .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),
      
        role: Yup.string().when("type", (type, schema) =>
          typeStatus ? schema.required("Required Role field") : schema
        ),

        client_code: Yup.string()
            .max(10, "Must be 10 characters or less")
            .required("Required client code field")
            .matches(/^$|^\S+.*/, "Only blankspaces is not valid."),

      }), 
    onSubmit: (values) => {
      const type = rolesOptions.filter((role) => role?.id === values.role);
      // const state = values?.country + "-" + values?.region;
      // const generalPractitionersSelected = generalPractitionerData.filter((data) => values?.general_practitioner.includes(data?.id));
      // let phoneNumber = createContactNumber(values);
      let encryptedData = {
        account_name: encryptData(values?.account_name.toLowerCase()),
        // last_name: encryptData(values?.last_name.toLowerCase()),
        full_name: encryptData(
          [
            values?.account_name.toLowerCase(),
            // values?.last_name.toLowerCase(),
          ].join(" ")
        ),
        type: encryptData(values?.type.toLowerCase()),
        email: encryptData(values?.email?.toLowerCase()),
        client_code: encryptData(values?.client_code),
        
      };
      
      setBtnLoading(true);
      const selectedLocationData =
        locations?.filter(
          (location) => location?.id === values?.clinic_location
        )?.[0] || null;
      editUser(
        values,
        encryptedData,
        organizationsData,
        null,
        type,
        [],
        selectedLocationData,
        values.organization//adminOrgs?.[0]?.id
      )
        .then(async (res) => {
          if (res.status === true) {
            console.log("res", res?.data);
            navigate("/app/identities/api-accounts");
            success(res?.message);
            handleShow();
            refreshTable();
          } else {
            failed(res.error);
          }
        })
        .catch((res) => {
          failed(
            res?.response?.data?.message ||
            res?.response?.data?.error ||
            res.message
          );
        })
        .finally(() => setBtnLoading(false));
    },
  });
  
  const handleFormChange = (e) => {
    if (e?.target?.id === "organization") {
      const selected_org =
        e?.target?.id === "organization"
          ? e?.target?.value
          : formik?.values?.organization;
    } 
  };

  useEffect(() => {
    getCustomRoles(["000000"])
      .then((res) => {
        formik.setFieldValue("role", res.data.filter(role => role.code == "newticket")[0].id);
        setRolesOptions(
          res?.data?.map(
            (role) => (role = { ...role, name: role?.display, value: role?.id })
          )
        );
      })
      .catch((res) => {
        failed(
          res?.response?.data?.message ||
          res?.response?.data?.error ||
          res.message
        );
      });
    
  }, [])

  useEffect(() => {   
    if (modalShow?.id) {
        setLoadingUserData(true);
        typeOfUser = typeOfUser ;      
        const apiBody = {
          id: modalShow?.id,
          type: typeOfUser,
          userOrgId: adminOrgs?.[0]?.id
        };
        getSingleUser(apiBody)
          .then( async (res) => {              
            let typeObj = {};
            // if( res?.data?.type != "Practitioner"){
            //   res?.data?.type?.forEach((element) => {
            //     typeObj[element] = element;
            //   });
            // }
            res?.data?.type?.forEach((element) => {
              typeObj[element] = element;
            });
            setCreatedAt(res?.data?.createdAt);
            //Setting common fields for all user type
            let countryRegion = res?.data?.address?.[0]?.state?.split("-");
            let organization =
              res?.data?.managingOrganization?.[0]?.reference?.split("/").pop();
            formik.setFieldValue(
              "account_name",
              decryptData(res?.data?.name?.[0]?.text || "")
            );
            formik.setFieldValue(
              "email",
              decryptData(
                res?.data?.telecom?.find((ele) => ele?.system === "email")
                  ?.value || ""
              )
            );
            formik.setFieldValue("id", res?.data?.id || "");
            formik.setFieldValue("organization", organization || "");
            formik.setFieldValue("client_code", res?.data?.client_code)
            await setCTIstatus(organization);

            return {
              selected_org: organization?.[1],
              scopeOfPrac: res?.data?.address?.[0]?.state,
            };
          })
          .then((res) => {
            let isSelfOrg = true;
            
          })
          .catch((res) => {
            failed(
              res?.response?.data?.message ||
              res?.response?.data?.error ||
              res?.message
            );
          })
          .finally(() => {
            setLoadingUserData(false);
            formik.setErrors({}) 
          });
      }   
    }, [modalShow]);

  return (
    <Modal
      backdropClassName
      backdrop={"static"}
      show={modalShow}
      onHide={handleShow}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="custom-dialog"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          API Account Details
        </Modal.Title>
        <div className="" ><Switch
            checked={modalShow?.active}
            onChange={()=> handleSwitch()} // Use the callback function
            color="primary"
            disabled={isReadOnly} 
        /></div>
      </Modal.Header>
      <Modal.Body>
        <form
          className="common-form border-fields userAccount"
          onSubmit={formik.handleSubmit}
          onChange={handleFormChange}
        >
          <Row>
              <Col md={3}>
                  <SelectFiled
                    keyField={"organization"}
                    label={"Select Organization"}
                    formik={formik}
                    options={organizations}
                    onChange={handleOrgChange}
                    readOnly={isReadOnly}
                  />
              </Col>
            <Col></Col>
            <Col style={{display:"flex", placeContent: "flex-end"}}>
                  <Tooltip style={{}}>
                    <div
                      style={{ marginRight: "1rem", cursor: "pointer",maxHeight: "24px" }}
                      onClick={() => handleShow()}
                    >
                      <Clear />
                    </div>
                  </Tooltip>
            </Col>
          </Row>
        
          <Fields fields={editBasicFieldsAPI} formik={formik} isReadOnly={false}  />

        <Row>
            <Col>
            {hasAccess  && ( 
              <>
                <Button style={{marginRight: "20px"}}
                  onClick={() => {
                    handleShow();
                  }}
                  variant="secondary"
                  title="Cancel"
                >
                  Cancel
                </Button>
                <Button type="submit" isLoading={btnLoading}><img src={UpdateDetailsIcon}/> Update</Button> 
              </>
            )}
          </Col>
            <Col style={{ display: "flex", justifyContent:"flex-end"}}>
                <div style={{alignSelf:"flex-end"}}>
                  API Account Created on {ViewDate(createdAt)}
                </div>
            </Col>
          </Row>
        </form>
      </Modal.Body>
    </Modal>
  );
}

export default EditApiAccount;
